exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-main-bottom[data-v-01b3f466]{position:fixed;bottom:0;right:0;left:0;padding:0.2rem 0.4rem;background:#fff;text-align:right;min-width:calc(100vw - 3.2rem);box-shadow:0px 8px 20px 8px rgba(0,0,0,0.05);transition:all 0.3s ease}\n", ""]);

// exports
